module.exports = {
      id: "default-author-image-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#default-author-image",
      toString: function () {
        return this.url;
      }
    }